import { render, staticRenderFns } from "./v-dummy-navigation.vue?vue&type=template&id=4df82156&scoped=true&"
import script from "./v-dummy-navigation.vue?vue&type=script&lang=js&"
export * from "./v-dummy-navigation.vue?vue&type=script&lang=js&"
import style0 from "./v-dummy-navigation.vue?vue&type=style&index=0&id=4df82156&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df82156",
  null
  
)

export default component.exports